import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { Observable } from 'rxjs';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { NAVIGATION } from 'src/app/middleware/common/Enum/common.enum';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { map, startWith } from 'rxjs/operators';
import { LoaderService } from '../../loader/loader.service';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-ai-detail',
  templateUrl: './ai-detail.component.html',
  styleUrls: ['./ai-detail.component.scss']
})

export class AiDetailComponent implements OnInit {

  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  stateCtrlValue: string;
  objectList: any = [];
  toggleChangeCore = false;

  ShowAttchedToCore: boolean = true;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;

  checkedAttachCore: boolean = true;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
  attachedToSelectedCompany: any = [] = [];

  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  attachedToCompanyList: any = [] = [];

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];

  selectedCoreId:number=0;
  selectedContactId:number=0;
  selectedCompanyId:number=0;

  CreateField:boolean=true;
  Finish:boolean=true;
  fieldListFiltered:any=[];
  selectedFileArray: any = [] = [];

  fieldListFilteredAI:any=[];

  name: string=""; 
  email: string=""; 

  timeout = null;  

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  
  transactionID: number=0;
  folderID: number=0;

  imageUrl: string=""; 
  status: string=""; 

  showAddCore:boolean = false;
  searchName:string="";
  isShare: boolean = false;
  Module:string="";

  organizationId: string;
  databaseId: string;
  responseHolder: any;
  LoggedInEmailId: string = "";
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  typeId:any;

  feildsCtrl: FormControl;
  feildsCtrlAI: FormControl;

  filteredFeilds: any=[]=[];
  filteredFeildsAI: any=[]=[];

  Feildproperty:any=[] = []; 
  FeildpropertyAI:any=[] = []; 

  synonymFieldsAI:any=[]=[];
  systemFieldsAI:any=[]=[];
  items:any=[]=[];
  navbar = ['OCR', 'NLP', 'CODES'];
  thumbs = [
    {
      src: '../../../../../assets/images/1.jpg',
      pageNumber:1
    },
    {
      src: '../../../../../assets/images/2.jpg',
      pageNumber:2
    },
    {
      src: '../../../../../assets/images/3.jpg',
      pageNumber:3
    },
    {
      src: '../../../../../assets/images/4.jpg',
      pageNumber:4
    },
    {
      src: '../../../../../assets/images/5.jpg',
      pageNumber:5
    },
    {
      src: '../../../../../assets/images/6.jpg',
      pageNumber:6
    },{
      src: '../../../../../assets/images/1.jpg',
      pageNumber:1
    },
    {
      src: '../../../../../assets/images/2.jpg',
      pageNumber:2
    },
    {
      src: '../../../../../assets/images/3.jpg',
      pageNumber:3
    },
    {
      src: '../../../../../assets/images/4.jpg',
      pageNumber:4
    },
    {
      src: '../../../../../assets/images/5.jpg',
      pageNumber:5
    },
    {
      src: '../../../../../assets/images/6.jpg',
      pageNumber:6
    },
  ];

    currentNavigation = NAVIGATION.AIData;

  constructor(private statusConst: StatusConstant,private dialog: MatDialog,
    private formsService: FormsService,private reusableClass: ReusableClasses,
    private encryptionAlgo: EncryptionService,private loaderService: LoaderService){ 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.LoggedInEmailId = sessionStorage.getItem('email');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.feildsCtrl = new FormControl();
    this.filteredFeilds = this.feildsCtrl.valueChanges.pipe(startWith(''),
    map((feilds) =>
    feilds ? this.filterFeilds(feilds) : this.Feildproperty.slice()));

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
    startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));

    }

    filterFeilds(name: string) {
      let arr = this.Feildproperty.filter((feilds) => feilds.fieldName.toLowerCase().indexOf(name.toLowerCase()) === 0);
      if(arr.length==0){
       this.CreateField=false;
       this.Finish=true;
      }
      return arr;
    }

    states = this.objectList;

    private _filterStates(value: string): State[] {
      const filterValue = value.toLowerCase();
      return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
    }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID=SelectedCore[0].folderID;
    }

    SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
      this.folderID=SelectedContact[0].folderID;
    }

    SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
      this.folderID=SelectedCompany[0].folderID;
    }
  }

  navigation(navigation: string): void{

    if(navigation === NAVIGATION.AIData){
      this.currentNavigation = NAVIGATION.AIData;
    }
    if(navigation === NAVIGATION.KeyValueData){
      this.currentNavigation = NAVIGATION.KeyValueData;
    }
    if(navigation === NAVIGATION.CODES){
      this.currentNavigation = NAVIGATION.CODES;
    }
  }

  ChangeCore(){
    this.toggleChangeCore = true;
    this.ShowAttchedToCore=true;
    this.CreateField=true;
    this.Finish=true; 
  }

  selectCCC($event: MatRadioChange) {
    this.stateCtrl.reset();
    this.transactionID=0;
    this.Finish=false;         

    if ($event.value === 'Core') {
      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;     
      var SelectedCore = [];

      SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
      if (SelectedCore.length > 0) {
       this.folderID = SelectedCore[0].folderID;
      }   
    }
    if ($event.value === 'Contact') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;  
      
      var SelectedContact = [];

      SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
      if (SelectedContact.length > 0) {
      this.folderID = SelectedContact[0].folderID;
      }
    }
    if ($event.value === 'Company') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;   
      
      var SelectedCompany = [];

      SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
      if (SelectedCompany.length > 0) {
       this.folderID = SelectedCompany[0].folderID;
      }
    }    
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];
  }
  
  
  //======================Core============================//

searchCore(val) {
  if (val.length >= 2) {
    this.attachedToCoreList = [];
    if (val != '') {
      this.searchName =val;
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchCore(val)
      }, 500);
    } else {
      this.attachedToCoreList = [];
    }
  }
}

getsearchCore(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
  if (SelectedCCC.length > 0) {
    this.CorefolderID = SelectedCCC[0].folderID;
  }
  this.roleIdList = [];
  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CorefolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.formsService.searchCore(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCoreList = response.data;
        this.attachedToCoreList.push(
          {           
            "coreID":0,
            "name":"Create New",
            "email":"",
            "imageUrl":"",
            "isShared":this.isShare,
            "coreContactUserMapID":0,
            "trasactionalRoleIds":[],           
            "shortName":""
          }
        )
      } else {
        this.attachedToCoreList = [];
      }
    }
  })
}


attchedToCoreSelected(coreSelected: any) {
  if(coreSelected.coreID == 0) { 
    this.stateCtrl.reset();
    this.dialog.closeAll();
    this.transactionID=0;    
   // this.addNew('Core');
    return;
   }

  var checkCore = [];
  this.stateCtrl.setValue('');
  checkCore = this.attachedToSelectedCore;
  if (checkCore.length == 0) {

    this.transactionID = coreSelected.coreID;
    this.imageUrl= coreSelected.imageUrl;
    this.status = coreSelected.status;
    this.typeId = coreSelected.typeID;

    this.name = coreSelected.name;
    this.email = coreSelected.email;

    this.selectedCoreId = coreSelected.coreID;

    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      coreID: coreSelected.coreID,
      email: coreSelected.email,
      name: coreSelected.name,        
      transactionID: coreSelected.transactionID,
      img: coreSelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedCore.unshift(ReqModel);
    this.stateCtrl.reset();
    if (this.attachedToSelectedCore.length > 0) {
      this.toggleChangeCore=false;
      this.ShowAttchedToCore=false;
      this.attachedToSelectedCore=[];

      // var checkw=[];
      // checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      // if(checkw.length>0){
      //   this.CreateField=false;
      //   this.Finish=true;
      // }else{
      //   this.CreateField=true;
      //   this.Finish=false;
      // }
    } else {
    
    }   
 }  
}


attchedToRemoveCore(item: any) {   
  const index = this.attachedToSelectedCore.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedCore.splice(index, 1);
  }
  if (this.attachedToSelectedCore.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    //this.showAddButton = false;
  }     
}



//======================Contact============================//

searchContacts(val) {
  if (val.length >= 2) {
    this.attachedToContactList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchContact(val)
      }, 500);
    } else {
      this.attachedToContactList = [];
    }
  }
}

getsearchContact(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
  if (SelectedCCC.length > 0) {
    this.ContactfolderID = SelectedCCC[0].folderID;
  }
  this.roleIdList = [];
  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.ContactfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.formsService.searchContact(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToContactList = response.data;
      } else {
        this.attachedToContactList = [];
      }
    }
  })
}


attchedToContactSelected(contactSelected: any) {
  var checkContact = [];
  this.stateCtrl.setValue('');
  checkContact = this.attachedToSelectedContact;
  if (checkContact.length == 0) {

    this.transactionID = contactSelected.contactID;
    this.imageUrl= contactSelected.imageUrl;
    this.status = contactSelected.status;
    this.typeId = contactSelected.typeID;

    this.selectedContactId = contactSelected.contactID;
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      contactID: contactSelected.contactID,
      email: contactSelected.email,
      name: contactSelected.name,      
      transactionID: contactSelected.transactionID,
      img: contactSelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedContact.unshift(ReqModel);
    this.stateCtrl.reset();
    // if (this.attachedToSelectedContact.length > 0) {
    //   this.showAddButton = true;
    // } else {
    //   this.showAddButton = false;
    // }   
  }  
}


attchedToRemoveContact(item: any) {
  const index = this.attachedToSelectedContact.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedContact.splice(index, 1);
  }
  if (this.attachedToSelectedContact.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    //this.showAddButton = false;
  }     
}





 //======================Company============================//

 searchCompany(val) {
  if (val.length >= 2) {
    this.attachedToCompanyList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchCompany(val)
      }, 500);
    } else {
      this.attachedToCompanyList = [];
    }
  }
}

getsearchCompany(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
  if (SelectedCCC.length > 0) {
    this.CompanyfolderID = SelectedCCC[0].folderID;
  }

  this.roleIdList = [];

  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CompanyfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.formsService.searchCompany(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCompanyList = response.data;
      } else {
        this.attachedToCompanyList = [];
      }
    }
  })
}


attchedToCompanySelected(companySelected: any) {
  var checkCompany = [];
  this.stateCtrl.setValue('');
  checkCompany = this.attachedToSelectedCompany;
  if (checkCompany.length == 0) {

    this.transactionID = companySelected.companyID;
    this.imageUrl= companySelected.imageUrl;
    this.status = companySelected.status;
    this.typeId = companySelected.typeID;

    this.selectedCompanyId = companySelected.companyID;
    var shortName = "";
    shortName = companySelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      companyID: companySelected.companyID,
      email: companySelected.email,
      name: companySelected.name,       
      transactionID: companySelected.transactionID,
      img: companySelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedCompany.unshift(ReqModel);
    this.stateCtrl.reset();
    // if (this.attachedToSelectedCompany.length > 0) {
    //   this.showAddButton = true;
    // } else {
    //   this.showAddButton = false;
    // }   
  }  
}


attchedToRemoveCompany(item: any) {
  const index = this.attachedToSelectedCompany.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedCompany.splice(index, 1);
  }
  if (this.attachedToSelectedCompany.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    //this.showAddButton = false;
  }   
}


  openSystemFields(templateRef: TemplateRef<any>){ 
     const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'synoniumModal'
     });
     this.ShowAddCustomFeildButton=false;   
     this.systemFieldsAI=[];
     this.selectedCustomFeilds=[];
     this.getSynonymsWithAI();
  }

  getSynonymsWithAI() {
    var ReqModel = {
     searchKey: '',
     folderID: this.folderID,
     isSearch: false,
     isReturnSynonyms: false,     
     userId: this.currentUser.UID,
     organizationID:  Number(this.organizationId),     
     officeID: this.myOfficeID,   
     }
     this.loaderService.showAILoader();
     this.formsService.getSynonyms(ReqModel).subscribe(response => {
     if(response != undefined) {
        this.responseHolder = response;
        this.loaderService.hideAILoader();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          //this.synonymFieldsAI=this.responseHolder.data.synonymFields;
          this.systemFieldsAI=this.responseHolder.data.systemFields;
          // if(this.synonymFieldsAI==null){
          //   this.synonymFieldsAI=[];
          // }
          if(this.systemFieldsAI==null){
            this.systemFieldsAI=[];
          }         
        }else{
          //this.synonymFieldsAI=[];
          this.systemFieldsAI=[];
          //this.FeildpropertyAI =[]; 
          this.loaderService.hideAILoader();         
        }
      }else{          
       //this.synonymFieldsAI=[];
       this.systemFieldsAI=[];
       this.loaderService.hideAILoader();
      }
    });
  } 

  closeAI(){
    this.systemFieldsAI=[];
    this.ShowAddCustomFeildButton=false;
    this.selectedCustomFeilds=[]; 
    this.dialog.closeAll();
  }

  ShowAddCustomFeildButton:boolean=false;
  selectedCustomFeilds:any=[]=[];
  CustomFeildsList:any=[]=[];

   //Checkbox Change detecting function
   getCheckboxValues(event, item) {   
    this.ShowAddCustomFeildButton = true;
    if (event.checked) {
      // let ReqModel = {
      //   fieldID: item.fieldID,
      //   fieldName:item.fieldName,
      // };
      this.selectedCustomFeilds.push(item);     
    } else {
      let removeIndex = this.selectedCustomFeilds.findIndex((itm) => itm.fieldID === item.fieldID);
      if (removeIndex !== -1) this.selectedCustomFeilds.splice(removeIndex, 1);    
    }
    if(this.selectedCustomFeilds.length == 0) {     
       this.ShowAddCustomFeildButton = false;      
    }
   }

   AddSystemFields(){
    if(this.selectedCustomFeilds.length>0){
      this.selectedCustomFeilds.forEach(e => {
        var obj={
         fieldID: e.fieldID,
         fieldName:e.fieldName,
        }
        this.CustomFeildsList.push(obj);
       }); 
    }
    this.dialog.closeAll();
   }
  
}
